import React,{useState, useEffect} from "react"
import { styled, useTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {Typography,Container, Divider, Drawer, Box, List} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import {makeStyles} from "@mui/styles"
import {createTheme} from "@mui/material/styles"
import {animateScroll as scroll} from "react-scroll"
import {Link as LinkS} from "react-scroll"
import "./Nav.css"

const theme = createTheme()

const useStyles = makeStyles({   
  all:{
    backgroundColor:"#1B2821"
  },
    menuIcon: {
      color:"#fff",
        [theme.breakpoints.up("sm")]:{
            display:'none'
            
        }
    },

    menu:{
        display:"flex",
        marginLeft:'25rem',
        cursor:"pointer",
        [theme.breakpoints.down("sm")]:{
            display:"none"
        },
        [theme.breakpoints.down("lg")]:{
            marginLeft:"10rem"

        }

    }
})

const drawerWidth = 240;

    const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
      ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: 0,
        }),
      }),
    );
    
    const AppBar = styled(MuiAppBar, {
      shouldForwardProp: (prop) => prop !== 'open',
    })(({ theme, open }) => ({
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }),
    }));
    
    const DrawerHeader = styled('div')(({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
   
    }));


const Navbar = ()=>{
    const classes = useStyles()
    const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [scrollNav, setScrollNav] = useState(false)
  
  const changeNav = ()=>{
    if(window.scrollY >= 80){
        setScrollNav(true)
    }else{
        setScrollNav(false)
    }
}
useEffect(()=>{
    window.addEventListener("scroll", changeNav)
}, [])



  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

    return(
     
        <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <AppBar position="fixed" open={open} scrollNav={scrollNav}>
        <Toolbar>
            <div className={classes.menuIcon}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }), color:"#fff" }}

          >
            <MenuIcon  />
        
          </IconButton>
          </div>
          <Typography variant="h5" noWrap component="div" data-aos="zoom-out-right">
            OLUKUNLE
          </Typography>

          <div className={classes.menu}>
          <Typography variant="h6" style={{marginLeft:"1.5rem", fontSize:"1.1rem"}} to="services" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>Services</Typography>
          <Typography variant="h6" style={{marginLeft:"1.5rem", fontSize:"1.1rem"}} to="about" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>About Me</Typography>
          <Typography variant="h6" style={{fontSize:"1.1rem", marginLeft:"1.5rem"}} to="skills" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>My Skills</Typography>
          
          <Typography variant="h6" style={{marginLeft:"1.5rem", fontSize:"1.1rem"}} to="portfolio" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>Portfolio</Typography>
          
          <Typography variant="h6" style={{marginLeft:"1.5rem", fontSize:"1.1rem"}} to="contact" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>Contact</Typography>
          </div>

        </Toolbar>
      </AppBar>
      <div>
      <Drawer 
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            // background:"#1B2821",
            // backgroundColor:"#fff",
                  
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
      
        <DrawerHeader>

          <IconButton onClick={handleDrawerClose}    className="drawerr">
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List className="drawerr">
          {[ <Typography variant="h6" style={{fontSize:"1.1rem"}} to="skills" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>My Skills</Typography>,
          <Typography variant="h6" style={{fontSize:"1.1rem"}} to="about" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>About Me</Typography>,
          <Typography variant="h6" style={{fontSize:"1.1rem"}} to="portfolio" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>Portfolio</Typography>,
          <Typography variant="h6" style={{fontSize:"1.1rem"}} to="services" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>Services</Typography>,
          <Typography variant="h6" style={{fontSize:"1.1rem"}} to="contact" smooth={true} duration={500} spy={true} exact="true"
          component={LinkS} offset={-80}>Contact</Typography>].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          {[<Typography variant="h6" style={{fontSize:"1rem"}}>+23481618824</Typography>,
          <Typography variant="h6" style={{fontSize:"1rem"}}>Olawuni50@gmail.com</Typography>,
          <Typography variant="h6" style={{fontSize:"1rem"}}>linkedin.com/in/olukunle-olawuni</Typography>,
          ].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      </div>
      <Main open={open}>
        <DrawerHeader />
        
      </Main>
    </Box>
    
    )
}

export default Navbar